module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/card-bb7a6a58a26df085505578a1b49d90a9.webp";